import { useMutation } from '@apollo/client';

import {
  ExternalActorType,
  Invoice,
} from 'lane-shared/domains/billingPayments/types';
import { useUserDataContext } from 'lane-shared/hooks';

import { markInvoiceAsBilledMutation } from './chargesInvoiceQueries';
import {
  MarkAsBilledError,
  mapMarkAsBilledError,
} from './mapMarkAsBilledError';

export type MarkAsBilledResult =
  | { status: 'billed' }
  | { status: 'failed'; error: MarkAsBilledError };

export function useMarkInvoiceAsBilled() {
  const { user } = useUserDataContext();
  const [markInvoiceAsBilled, { loading }] = useMutation(
    markInvoiceAsBilledMutation
  );

  const markAsBilled = async (
    invoice: Invoice
  ): Promise<MarkAsBilledResult> => {
    try {
      await markInvoiceAsBilled({
        variables: {
          markInvoiceAsBilledRequest: {
            invoiceId: invoice.id,
            groupId: invoice.groupId,
            externalActorId: user?._id || '',
            externalActorType:
              ExternalActorType.EXTERNAL_ACTOR_TYPE_ACTIVATE_USER,
          },
        },
      });

      return { status: 'billed' };
    } catch (err) {
      return { status: 'failed', error: mapMarkAsBilledError(err) };
    }
  };

  return { markAsBilled, isLoading: loading };
}
